import classNames from 'classnames'
import { useTheme } from '../context/themeContext'

/**
 * Shared favorite star icon that adapts to the current theme.
 * In dark mode a selected star glows mint green, while light mode keeps the blue fill.
 */
export default function FavoriteStar({ active = false, className }) {
  const { theme } = useTheme()
  const isDark = theme === 'dark'
  const activeFill = isDark ? '#1CF1B0' : '#3B82F6'
  const activeStroke = isDark ? '#00DFA2' : '#1E40AF'
  const inactiveFill = isDark ? '#111827' : '#E5E7EB'
  const inactiveStroke = isDark ? '#4B5563' : '#9CA3AF'
  const glowStyle = active
    ? {
        filter: isDark
          ? 'drop-shadow(0 0 8px rgba(0, 255, 170, 0.7))'
          : 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.65))'
      }
    : undefined

  return (
    <svg
      viewBox='0 0 24 24'
      width='16'
      height='16'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
      className={classNames(
        'transition-all duration-200 drop-shadow',
        { 'opacity-60': !active },
        className
      )}
      style={glowStyle}
    >
      <path
        d='M12 2.25l2.812 5.698 6.297.915-4.555 4.436 1.076 6.279L12 16.98l-5.63 2.598 1.076-6.279-4.555-4.436 6.297-.915L12 2.25Z'
        fill={active ? activeFill : inactiveFill}
        stroke={active ? activeStroke : inactiveStroke}
        strokeWidth='1.2'
        strokeLinejoin='miter'
        strokeLinecap='square'
      />
    </svg>
  )
}
